export const normalizeRole = (rawRole = "") => {
  if (!rawRole) return null;
  
  // Convert to string and clean it
  const role = String(rawRole).toLowerCase().replace(/[\s-_]/g, "");
  
  console.log("Normalizing role:", rawRole, "->", role);

  switch (role) {
    case "superadmin":
    case "admin":
      return "superadmin";

    case "projectadmin":
    case "projectadmin":
      return "projectadmin";

    case "support":
    case "supportagent":  // This handles "SUPPORT_AGENT" -> "supportagent"
    case "supportagent":  // Also handles "support_agent"
      return "support";

    case "employee":
    case "staff":
      return "employee";

    case "manager":
      return "manager";

    default:
      console.warn("Unknown role:", rawRole, "normalized to:", role);
      return null; // unknown role → block access
  }
};